import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { address } from './address';
import { SetField } from '../components/Table/fields/SetField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPBooleanField } from '../components/Table/fields/SPBooleanField';
import { AccommodationContact } from '../components/Contacts/AccommodationContact';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { AccommodationAttachment } from '../components/Images/AccommodationAttachment';
import { AccommodationImages } from '../components/Images/AccommodationImages';
import { AccommodationVenues } from '../components/Venues/AccommodationVenues';
import { BooleanField } from '../components/Table/fields/BooleanField';
import { AccommodationCorporateComponent } from '../components/LegalAndFinance/AccommodationCorporate';
import { SPSetAddressField } from '../components/Table/fields/SPSetAddressField';
import {SPSelectWithOutAutocomplete} from "../components/Table/fields/SPSelectWithOutAutocompleteField";
import {SPRateField} from "../components/Table/fields/SPRateField";
import {Prices} from "../components/Accommodation/Prices";

export const accommodation: SchemaWithClient<any> = {
  name: 'Accommodation Providers',
  pluralName: 'Accommodation Providers',
  filters: {
    accommodation_category: {
      name: 'Category',
      schema: enumItems.accommodationCategory,
    },
  },
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
    {
      id: 2,
      label: 'Contacts',
      name: 'contacts',
      type: 'custom',
      renderer: AccommodationContact,
      rendererType: 'contacts',
    },
    {
      id: 4,
      label: 'Address',
      name: 'address',
      type: 'custom',
      renderer: AccommodationVenues,
      rendererType: 'venues',
    },
    {
      id: 5,
      label: 'Images',
      name: 'images',
      type: 'custom',
      renderer: AccommodationImages,
      rendererType: 'images',
    },
  ],

  sections: [
    {
      id: 1,
      width: 12,
      label: 'General Data',
      name: 'general',
      hasDefaultButtons: true,
      grids: [
        {
          width: 4,
          columns: [
            {
              columnName: 'name',
              name: 'Name',
              fieldRenderer: SPTextField,
            },
            {
              name: 'Company',
              fieldRenderer: SPTextField,
              columnName: 'legal_name',
            },
            {
              columnName: 'description',
              name: 'Description',
              fieldRenderer: SPRichTextField,
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              name: 'Category',
              fieldRenderer: SPSelectField.tableAdapter(
                enumItems.accommodationCategory
              ),
              columnName: 'activity_category',
            },
            /*{
              name: 'Type',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.activityType),
              columnName: 'activity_type',
            },*/
            {
              name: 'Availability',
              fieldRenderer: SPRichTextField,
              columnName: 'availability',
            },
            {
              name: 'Notes',
              fieldRenderer: SPRichTextField,
              columnName: 'notes',
            },
          ],
        },
        {
          width: 4,
          columns: [
            /* {
              name: 'Default provider',
              fieldRenderer: SPBooleanField,
              columnName: 'default_provider',
            },*/
            {
              name: 'Active',
              fieldRenderer: SPBooleanField,
              columnName: 'active',
            },
            {
              name: 'Websites',
              fieldRenderer: SPRichTextField,
              columnName: 'website',
            },
            {
              name: 'Hotline',
              fieldRenderer: SPTextField,
              columnName: 'hotline',
            },
          ],
        },
      ],
    },
    {
      id: 1,
      width: 12,
      label: 'Public Website',
      name: 'public_website',
      grids: [
        {
          width: 4,
          columns: [
            {
              columnName: 'pricing',
              name: 'Pricing',
              fieldRenderer: SPRichTextField,
            },
            {
              columnName: 'subheader',
              name: 'Subheader',
              fieldRenderer: SPRichTextField,
            },
            {
              columnName: 'capacity',
              name: 'Capacity',
              fieldRenderer: SPRichTextField,
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              columnName: 'website_description',
              name: 'Description',
              fieldRenderer: SPRichTextField,
            },
            {
              columnName: 'website_includes',
              name: 'Includes',
              fieldRenderer: SPRichTextField,
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              name: 'Pricing Rate',
              fieldRenderer: SPRateField,
              columnName: 'pricing_rate',
            },
            {
              name: 'Public Website Active',
              fieldRenderer: SPBooleanField,
              columnName: 'public_website_active',
            },
          ],
        },
      ],
    },
    {
      id: 2,
      width: 6,
      label: 'Contacts',
      name: 'contacts',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'contacts',
              fieldRenderer: AccommodationContact,
            },
          ],
        },
      ],
    },
    {
      id: 9,
      width: 6,
      label: 'Addresses',
      name: 'venues',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'venues',
              fieldRenderer: AccommodationVenues,
            },
          ],
        },
      ],
    },
    {
      id: 10,
      width: 12,
      label: 'Prices',
      name: 'prices',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'prices',
              fieldRenderer: Prices,
            },
          ],
        },
      ],
    },
    {
      id: 4,
      width: 8,
      label: 'Legal & Finance',
      name: 'corporates',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'corporates',
              fieldRenderer: AccommodationCorporateComponent,
            },
          ],
        },
      ],
    },
    /* {
      id: 5,
      width: 8,
      label: 'Rooms',
      name: 'rooms',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'rooms',
              fieldRenderer: Rooms,
            },
          ],
        },
      ],
    },*/
    {
      id: 6,
      width: 4,
      label: 'Accommodation Information',
      name: 'accommodation_information',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'information',
              name: 'Accommodation Information',
              fieldRenderer: SPRichTextField,
            },
            {
              columnName: 'breakfast_price',
              name: 'Breakfast Price',
              fieldRenderer: SPNumberField,
            },
            {
              columnName: 'breakfast_price_currency',
              name: 'Breakfast Price Currency',
              fieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(enumItems.currency),
            },

            /*    {
              columnName: 'partner_price',
              name: 'Partner Price',
              fieldRenderer: SPBooleanField,
            },
            {
              columnName: 'partner_fix_price',
              name: 'Partner Fix Price',
              fieldRenderer: SPNumberField,
            },
            {
              columnName: 'partner_fix_price_currency',
              name: 'Partner Fix Price Currency',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
            },
            {
              columnName: 'partner_discount',
              name: 'Discount',
              fieldRenderer: SPNumberField,
            },
            {
              columnName: 'partner_price_description',
              name: 'Partner Price Description',
              fieldRenderer: SPRichTextField,
            },*/
          ],
        },
      ],
    },
    {
      id: 7,
      width: 4,
      label: 'Attachments',
      name: 'attachments',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'attachments',
              fieldRenderer: AccommodationAttachment,
            },
          ],
        },
      ],
    },
    {
      id: 8,
      width: 8,
      label: 'Images',
      name: 'images',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'images',
              fieldRenderer: AccommodationImages,
            },
          ],
        },
      ],
    },
  ],

  columns: {
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    accommodation_category: {
      name: 'Accommodation Category',
      fieldRenderer: SelectField.tableAdapter(enumItems.accommodationCategory),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.accommodationCategory
      ),
      switchboard: true,
      url: enumItems.accommodationCategory.client.getAllPath,
      tempSchema: enumItems.accommodationCategory,
    },
    description: {
      name: 'Description',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
    },
    addresses: {
      name: 'Addresses',
      fieldRenderer: SetField.tableAdapter(address),
      slidePaneFieldRenderer: SPSetAddressField.tableAdapter(address),
      multiSwitchboard: true,
      url: address.client.getAllPath,
      tempSchema: address,
      fieldType: 'address-line',
    },
    notes: {
      name: 'Notes',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'editable-textarea',
    },
    website: {
      name: 'Website',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
    },
    information: {
      name: 'Accommodation Information',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
    },
    breakfast_price: {
      name: 'Breakfast Price',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    breakfast_price_currency: {
      name: 'Breakfast Price Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
      multiSwitchboard: true,
    },
    legal_name: {
      name: 'Legal Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    hotline: {
      name: 'Hotline',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    pricing: {
      name: 'Pricing',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    subheader: {
      name: 'Subheader',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    capacity: {
      name: 'Capacity',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    website_description: {
      name: 'Website Description',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    website_includes: {
      name: 'Website Includes',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    pricing_rate: {
      name: 'Pricing Rate',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPRateField,
      //fieldType: 'boolean',
      section: 'general',
    },
    public_website_active: {
      name: 'Public Website',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
      section: 'general',
      defaultShow: true,
    },

    /*contacts: {
      name: 'Contacts',
      fieldRenderer: SetField.tableAdapter(enumItems.user),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.user),
      multiSwitchboard: true,
      url: enumItems.user.client.getAllPath,
      tempSchema: enumItems.user,
    },
    ifa_value: {
      name: 'IFA Value',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'number',
      defaultShow: false,
    },
    ifa_metric: {
      name: 'IFA Metric',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      defaultShow: false,
    },*/

    active: {
      name: 'Active',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
      hide: true,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
      defaultShow: false,
    },
  },
  viewTable: 'accommodations',
  client: new Client('/accommodations'),
};
